/**
 * @generated SignedSource<<92b178a8c9228fd8b22561f4e16ba1ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PopupImportJobStatus = "QUEUED" | "RUNNING" | "COMPLETED" | "COMPLETED_WITH_ERRORS" | "FAILED" | "%future added value";
export type PopupListPageJobStatusQuery$variables = {
  slug: string;
};
export type PopupListPageJobStatusQueryVariables = PopupListPageJobStatusQuery$variables;
export type PopupListPageJobStatusQuery$data = {
  readonly popupImportJob: {
    readonly slug: string;
    readonly status: PopupImportJobStatus;
    readonly totalCount: number;
    readonly succeededCount: number;
    readonly failedCount: number;
    readonly retryCsv: string | null;
    readonly errorMessage: string | null;
  } | null;
};
export type PopupListPageJobStatusQueryResponse = PopupListPageJobStatusQuery$data;
export type PopupListPageJobStatusQuery = {
  variables: PopupListPageJobStatusQueryVariables;
  response: PopupListPageJobStatusQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "succeededCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failedCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retryCsv",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupListPageJobStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PopupImportJob",
        "kind": "LinkedField",
        "name": "popupImportJob",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupListPageJobStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PopupImportJob",
        "kind": "LinkedField",
        "name": "popupImportJob",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "604525194547db38c35f81b249c0062c",
    "id": null,
    "metadata": {},
    "name": "PopupListPageJobStatusQuery",
    "operationKind": "query",
    "text": "query PopupListPageJobStatusQuery(\n  $slug: String!\n) {\n  popupImportJob(slug: $slug) {\n    slug\n    status\n    totalCount\n    succeededCount\n    failedCount\n    retryCsv\n    errorMessage\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a5c44e8eba9d8b00609628fbaa63511";

export default node;
